<template>
  <div class="TranProgramModuleActivity-view-page w-100">
    <basic-subheader>
      <template v-slot:actions>
        <b-button class="btn ml-3" type="button" @click="returnPage">
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Arrows/arrow-left.svg" />
          </span>
          Trở về trước
        </b-button>
        <b-button
          class="btn btn-inactive ml-3"
          type="button"
          v-if="tranProgramModuleActivityData.isActive && isDeletePermission"
          @click="handleInactive(tranProgramModuleActivityData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/power.svg" />
          </span>
          Inactive
        </b-button>
        <b-button
          class="btn btn-active ml-3"
          type="button"
          v-if="!tranProgramModuleActivityData.isActive && isDeletePermission"
          @click="handleInactive(tranProgramModuleActivityData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/power.svg" />
          </span>
          Active
        </b-button>
        <b-button
          class="btn btn-success ml-3"
          type="button"
          v-if="isDeletePermission"
          @click.stop="handleUpdate(tranProgramModuleActivityData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/edit-2.svg" />
          </span>
          Chỉnh sửa
        </b-button>
      </template>
    </basic-subheader>
    <b-overlay :show="loading">
      <b-container fluid class="TranProgramModuleActivity-view-page__body mb-6 mt-6">
        
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">Id:</div>
                    <div>
                        {{ tranProgramModuleActivityData.id }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">Code:</div>
                    <div>
                        {{ tranProgramModuleActivityData.code }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">IsDeleted:</div>
                    <div>
                        {{ tranProgramModuleActivityData.isDeleted }}
                    </div>
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">CreateDatetime:</div>
                    <div>
                        {{ tranProgramModuleActivityData.createDatetime }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">UpdateDatetime:</div>
                    <div>
                        {{ tranProgramModuleActivityData.updateDatetime }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">CreatorId:</div>
                    <div>
                        {{ tranProgramModuleActivityData.creatorId }}
                    </div>
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">UpdaterId:</div>
                    <div>
                        {{ tranProgramModuleActivityData.updaterId }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">IsActive:</div>
                    <div>
                        {{ tranProgramModuleActivityData.isActive }}
                    </div>
            </b-col>
            <b-col>
                
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
            </b-col>
            <b-col>
                
                    <div class="text-muted">IsCustom:</div>
                    <div>
                        {{ tranProgramModuleActivityData.isCustom }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">StartranAtranDay:</div>
                    <div>
                        {{ tranProgramModuleActivityData.startranAtranDay }}
                    </div>
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">Status:</div>
                    <div>
                        {{ tranProgramModuleActivityData.status }}
                    </div>
            </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      isFirstLoad: false,
      TranProgramModuleActivityData: {},
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
    isDeletePermission() {
      let roles = this.currentUser?.roles;
      if (roles && roles.length) {
        return roles.includes('Admin');
      } else {
        return false;
      }
    },
  },
  methods: {
    returnPage() {
      this.$router.push({
        name: 'tranProgramModuleActivity_list',
      });
    },
    handleUpdate(item) {
      this.$router.push({
        name: 'tranProgramModuleActivity_detail',
        params: {
          form_type: 'edit',
          id: item.id,
        },
      });
    },
    handleInactive(item) {
      let text = item.isActive ? 'Inactive' : 'Active';
      let btn = item.isActive ? 'btn-inactive' : 'btn-active';
      this.$swal({
        title: '',
        text: `Bạn có chắc muốn ${text} app user ${item.id} không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: `${text}`,
            value: true,
            visible: true,
            className: `btn ${btn}`,
            closeModal: true,
          },
        },
      }).then(
        function (result) {
          if (result) {
            // inactive all
            this.inactiveItem(item)
              .then(() => {
                this.loadTranProgramModuleActivityData();
                this.$swal(
                  'Thành công!',
                  'Chúc mừng, bạn đã cập nhật thông tin TranProgramModuleActivity thành công!',
                  'success',
                );
              })
              .catch(() => {
                this.$swal('Lỗi!', 'Đã có lỗi xảy ra.', 'error');
              });
          }
        }.bind(this),
      );
    },
    async inactiveItem(item) {
      this.loading = true;
      try {
        let payload = new FormData();
        payload.append('id', item.id);
        payload.append('active', !item.isActive);
        await this.$api.put(`TranProgramModuleActivity`, payload);
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
    async loadTranProgramModuleActivityData() {
      if (!this.$route.params.id) return;
      try {
        this.loading = true;
        const id = this.$route.params.id;
        let { data } = await this.$api.get(`TranProgramModuleActivity/${id}`);
        this.tranProgramModuleActivityData = data;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.loadTranProgramModuleActivityData();
  },
};
</script>
